import zj_pie from './zj-pie';
import zj_bar from './zj-bar';

export default (Vue) => {
    Vue.component("zjPie", zj_pie);
    Vue.component("zjBar", zj_bar);
}